import { HttpErrorResponse } from '@angular/common/http';
import { IFieldError } from '../models/service-change-request-config-steps-forms.model';
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

export const ExtractHttpErrorFieldErrorsUtil = (
  error: HttpErrorResponse
): IFieldError[] => {
  return error?.error?.fieldErrors ?? [];
};

export const isFormControlNotEmpty = (
  control?: AbstractControl | null
): boolean => {
  if (control instanceof FormControl) {
    const value = control.value;
    return value !== null && value !== undefined && value !== '';
  }

  if (control instanceof FormGroup) {
    return Object.values(control.controls).some(child =>
      isFormControlNotEmpty(child)
    );
  }

  if (control instanceof FormArray) {
    return control.controls.some(child => isFormControlNotEmpty(child));
  }

  return false;
};
